import React, { useEffect, useState } from "react";
import ImageSlider from "../common/ImageSlider";
import { settings } from "../../constants/spaceFeedImageSettings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons"; // Importing the star icon from Font Awesome
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/config";
import { toast } from "react-toastify";
import "../../styles/searchlist.css";

const SearchList = ({ showMap, searchResponse }) => {
  let auth = localStorage?.getItem("data");
  auth = JSON.parse(auth);


  // const [width, setWidth] = useState(window.innerWidth);
  // useEffect(() => {
  //   //console.log"width>>>>>",width);
  //   const handleResize = () => setWidth(window.innerWidth);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const [favouriteList, setFavouriteList] = useState([]);
  const navigate = useNavigate();

  const fetchFavouriteList = async () => {
    try {
      const response = await api.get("/shortlisted-space-feed");
      if (response?.data?.status === 200) {
        setFavouriteList(response?.data?.response);
      }
    } catch (error) {
      //console.logerror);
    }
  };
  useEffect(() => {
    if (!!auth?.jwt) {
      fetchFavouriteList();
    }
  }, []);

  const handleStarClick = (e, id) => {
    //e.preventDefault();
    const isFavourite = favouriteList.some((item) => item?.spaceFeedId === id);
    const updatedFavourites = isFavourite
      ? favouriteList.filter((product) => product?.spaceFeedId !== id)
      : [...favouriteList, { spaceFeedId: id }]; // Add product if not already favourited
    setFavouriteList(updatedFavourites);

    handleFavourite(id, isFavourite ? 0 : 1);
  };

  const handleFavourite = async (id, action) => {
    if (!!auth?.jwt) {
      try {
        await api.post(`shortlist-space-feed/${id}/${action}`);
        // //console.logauth.role , "Hello")
        toast.success(
          `${action === 1 ? "Added to Favourite" : "Removed from Favourite"}`
        );
        // //console.logauth.role , "Hello")
      } catch (error) {
        toast.error("Error adding or removing from favorites!");
        console.error(error, "error");
      }
    } else {
      navigate("/login");
    }
  };
  const handleImageClick = (id) => {
    navigate(`/property-detail/${id}`);
  };
  return (
    <>
      <div className={`row custom-mapsize ${showMap ? "mapWidth" : "w-100"}`}>
        <div
          className={`mt-2 col-12 ${showMap ? "list-scroll" : ""}`}
          style={{
            backgroundColor: "#fff",
            height: "calc(100vh - 100px)",
            overflowY: "auto",
          }}
        >
          <div className="card-community mt-1 shadow">
            <div className="card-body">
              <div className={`${showMap ? "" : "row"}`}>
                {searchResponse?.map((item) => (
                  <div
                    className={` mt-2 mb-2 ${
                      showMap ? "col-lg-12" : "col-lg-4"
                    }`}
                  >
                    <Link style={{ textDecoration: "none" }}>
                      <div className="card w-100  ">
                        {item?.spaceFeedMedia?.length > 0 && (
                          <>
                            {item?.spaceFeedMedia.length === 1 ? (
                              <>
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "300px",
                                  }}
                                >
                                  {item?.spaceFeedMedia[0]?.url?.includes(
                                    "mp4"
                                  ) ? (
                                    <>
                                      <video
                                        type="video/mp4"
                                        className="card-img-top"
                                        src={item?.spaceFeedMedia[0]?.url}
                                        alt="Card cap"
                                        controls
                                        style={{
                                          position: "absolute",
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                        onClick={(e) => {
                                          navigate(
                                            `/property-detail/${item?.spaceFeedId}`
                                          );
                                        }}
                                      />
                                      {auth?.role === "user" && (
                                        <FontAwesomeIcon
                                          icon={faStar}
                                          onClick={(e) =>
                                            handleStarClick(
                                              e,
                                              item?.spaceFeedId
                                            )
                                          }
                                          className="star-icon"
                                          style={{
                                            color:
                                              !!auth?.jwt &&
                                              favouriteList.some(
                                                (favProduct) =>
                                                  favProduct.spaceFeedId ===
                                                  item?.spaceFeedId
                                              ) &&
                                              "#F5C000",
                                            cursor: "default",
                                          }}
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <img
                                      className="card-img-top"
                                      src={
                                        item?.spaceFeedMedia[0]?.url ||
                                        "https://picsum.photos/seed/picsum/200/200"
                                      }
                                      alt="Card cap"
                                      height={300}
                                      onClick={(e) => {
                                        navigate(
                                          `/property-detail/${item?.spaceFeedId}`
                                        );
                                      }}
                                    />
                                  )}
                                  {auth?.role === "user" && (
                                    <FontAwesomeIcon
                                      icon={faStar}
                                      onClick={(e) =>
                                        handleStarClick(e, item?.spaceFeedId)
                                      }
                                      className="star-icon"
                                      style={{
                                        color:
                                          !!auth?.jwt &&
                                          favouriteList.some(
                                            (favProduct) =>
                                              favProduct.spaceFeedId ===
                                              item?.spaceFeedId
                                          ) &&
                                          "#F5C000",
                                        cursor: "default",
                                      }}
                                    />
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <ImageSlider
                                  height={300}
                                  className="card-img-top"
                                  settings={settings}
                                  item={item}
                                  auth={auth}
                                  style={{
                                    color:
                                      !!auth?.jwt &&
                                      favouriteList.some(
                                        (favProduct) =>
                                          favProduct.spaceFeedId ===
                                          item?.spaceFeedId
                                      ) &&
                                      "#F5C000",
                                    cursor: "default",
                                  }}
                                  handleClick={handleStarClick}
                                  handleImageClick={handleImageClick}
                                />
                              </>
                            )}
                          </>
                        )}
                        <div
                          className="card-body"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/property-detail/${item?.spaceFeedId}`);
                          }}
                        >
                          <h5 className="card-title text-body">{item?.name}</h5>
                          {/* <h6 className="text-body">Restaurant Space</h6> */}
                          <span className="text-black-50">
                          {item?.address1
  ?.replace(/USA/i, "")
  ?.replace(/\bUnited States\b/gi, '')
  ?.replace(/\bNew York\b,?\s*/gi, '')
  .replace(/,\s*$/, "")}
</span>

                          <br />
                          {/* <span className="text-black-50">
  {item?.city && item?.state
    ? `${item.city}, ${item.state}`.replace(/,?\s*USA/, '')
    : ''}
</span> */}
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`mt-2 custom-mapsize ${showMap ? "d-block mapWidth " : "d-none"}`}
        style={{
          backgroundColor: "#fff",
          height: "calc(100vh - 10px)",
          overflow: "hidden",
        }}
      >
        <div>
          <div className="mt-2">
            <div
              className="map-container"
              style={{
                width: "100%",
                transition: "width 0.5s ease-in-out",
                position: "relative",
              }}
            >
              <div
                id="map"
                style={{ width: "100%", height: "calc(100vh - 100px)" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchList;
